import { useEffect } from 'react';
import { useTranslation } from '@shared/i18n';
import { useTelegramLink, useTelegramStatus } from '../hooks/useTelegram';
import { TelegramStatusBadge } from './TelegramStatusBadge';

export function TelegramConnectCard() {
  const { t } = useTranslation();
  const { data: status } = useTelegramStatus();
  const { mutate: generateLink, data: linkData, isPending, error, reset } = useTelegramLink();

  const isLinked = status?.linked ?? false;

  useEffect(() => {
    if (!isLinked && !linkData && !isPending) {
      generateLink();
    }
  }, [isLinked, linkData, isPending, generateLink]);

  if (isLinked) {
    return (
      <div className="card p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900">Telegram</h3>
          <TelegramStatusBadge linked />
        </div>
        <p className="text-sm text-gray-600 mb-4">{t('telegram.manage_via_bot')}</p>
        <button
          onClick={() => {
            reset();
            generateLink();
          }}
          className="btn btn-outline text-sm"
        >
          {t('telegram.reconnect')}
        </button>
      </div>
    );
  }

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-medium text-gray-900">{t('telegram.connect_title')}</h3>
        <TelegramStatusBadge linked={false} />
      </div>
      <p className="text-sm text-gray-500 mb-4">{t('telegram.connect_description')}</p>

      {isPending && <p className="text-sm text-gray-500">{t('telegram.generating')}</p>}

      {error && (
        <div className="mb-4">
          <div className="text-sm rounded-lg p-3 bg-red-50 border border-red-200 text-red-700">
            {t('telegram.generate_error')}
          </div>
          <button onClick={() => generateLink()} className="btn btn-primary text-sm mt-3">
            {t('common.try_again')}
          </button>
        </div>
      )}

      {linkData && !isPending && !error && (
        <div className="space-y-4">
          <div className="flex justify-center">
            <img src={linkData.qrCodeDataUrl} alt="Telegram QR code" className="w-48 h-48" />
          </div>
          <div className="text-center">
            <a
              href={linkData.botUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary inline-block"
            >
              {t('telegram.open_in_telegram')}
            </a>
          </div>
          <p className="text-xs text-gray-400 text-center">{t('telegram.qr_expiry')}</p>
        </div>
      )}
    </div>
  );
}
